import styles from './RatingSelector.module.scss';

interface propTypes {
  selectedRating: number;
  setSelectedRating: React.Dispatch<React.SetStateAction<number>>;
}

export const RatingSelector = ({
  selectedRating,
  setSelectedRating,
}: propTypes) => {
  const ratings = [1, 2, 3, 4, 5];

  return (
    <div className={styles.container}>
      {ratings.map(rating => {
        return (
          <div
            key={rating}
            onClick={() => setSelectedRating(rating)}
            className={
              rating === selectedRating
                ? styles['circle-active']
                : styles.circle
            }
          >
            {rating}
          </div>
        );
      })}
    </div>
  );
};
